window.options.slickOptions.slidesToShow = 3;
